import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import {
  handleGetApiGF,
  OnLogout,
  Toast,
  Userlogin,
} from "./Utils/general-function";
import useApiData from "./useApiData";
import accountDeleteimg from "../src_img/account-delete.png";
import play_store_img from "../src_img/playstore.png";
import app_store_img from "../src_img/appstore.png";
import walletImg from "../src_img/wallet.png";
import alertImg from "../src_img/alert.png";
import bellgif from "../src_img/bellgif.gif";

const Header = React.memo((props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  const navigate = useNavigate();
  const menuRef = useRef(null);
  const [profiile, setProfile] = useState({
    firmname: sessionStorage.getItem("firmname"),
    firmimg: sessionStorage.getItem("firmimg"),
  });
  const location = useLocation();
  // console.log("location", location);
  const isHomePage = useRef(location?.pathname === "/");
  console.log("isHomePage", isHomePage);
  //  for not showing menubar in user with not upodeted profiile
  let nCity = "data";
  const params = useParams();

  if (props.updated === "") {
    nCity = props.updated;
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
        const btn = document.querySelector(".sharbtnpos");
        if (btn) {
          btn.style.display = "inline-flex";
        }
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const fetchNotificationCount = async () => {
    const res = await handleGetApiGF({
      url: "/api/LeadQRCode/GetUnreadLeadCount",
    });
    console.log("res not cou", res);

    if (!res?.succ) {
      Toast(false, "", res?.msg || "No new leads");
      return;
    }
    setNotificationCount(res?.data?.Data);
  };
  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
    }
    if (isHomePage.current) {
      // only fetch notification count on home page
      fetchNotificationCount();
    }
    console.log("window.location.href", window.location.href);

    if (
      window.location.href !== "http://localhost:3000/" &&
      window.location.href !== "https://m.carthi.in/"
    ) {
      let webIcons = document.querySelectorAll(".webIcons");
      console.log("webIcons", webIcons);
      if (webIcons?.length !== 0) {
        webIcons.forEach((div) => {
          console.log("div", div);

          div.style.display = "none";
        });
      }
    }
  }, []);

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
    const btn = document.querySelector(".sharbtnpos");
    if (btn) {
      btn.style.display = "none";
    }
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
    const btn = document.querySelector(".sharbtnpos");
    if (btn) {
      btn.style.display = "inline-flex";
    }
  };

  const fetchProfile = async () => {
    const profileRes = await handleGetApiGF({
      url: "/api/BrandingProfile/All",
    });
    if (!profileRes.succ) {
      Toast(false, "", profileRes?.msg);
      return;
    }

    const { Firmname, Logo } = profileRes?.data?.Data[0];
    sessionStorage.setItem("firmimg", Logo);
    sessionStorage.setItem("firmname", Firmname);
    setProfile((prev) => ({ ...prev, firmname: Firmname, firmimg: Logo }));
  };

  useEffect(() => {
    if (Userlogin() && (!profiile.firmname || !profiile.firmimg)) {
      fetchProfile();
    }
  }, []);

  const { firmname, firmimg } = profiile;

  return (
    <>
      <div className="fixheader">
        <header className="d-flex justify-content-between align-items-center">
          <div className="test d-flex flex-row align-items-center">
            {nCity && (
              <div className="menubtn" onClick={handleToggleMenu} ref={menuRef}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}

            <a href="/" className="logodiv">
              <img src="/assets/images/logo.png" alt="" />
            </a>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            {isHomePage.current && (
              <Link
                to="/leadtemporylistalert"
                style={{
                  marginRight: "15px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  lineHeight: "12px",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "min-content" }}>
                  <span
                    className="leadCount"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      background: "var(--prcolor)",
                      borderRadius: "100%",
                      textAlign: "center",
                      lineHeight: "14px",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "rgb(255, 255, 255)",
                      zIndex: "2",
                      right: "-10px",
                      top: "5px",
                      padding: "2px",
                      height: "16px",
                      minWidth: "16px",
                    }}
                  >
                    {" "}
                    {notificationCount}
                  </span>
                  <img
                    src={bellgif}
                    alt=""
                    width={50}
                    style={{
                      height: "22px",
                      width: "22px",
                    }}
                  />
                  {/* <img
                    src={alertImg}
                    alt=""
                    width={50}
                    style={{
                      maxWidth: "50px",
                      borderRadius: "100%",
                      padding: "5px",
                      height: "30px",
                      width: "30px",
                    }}
                  /> */}
                </div>
                <span style={{ fontSize: "14px" }}>Leads</span>
              </Link>
            )}

            <Link
              to="https://play.google.com/store/apps/details?id=com.app.carthi"
              className="webIcons"
              target="_blank"
              style={{ marginRight: "15px" }}
            >
              <img src={play_store_img} alt="" style={{ maxWidth: "50px" }} />
            </Link>
            <Link
              to="https://apps.apple.com/in/app/carthi-dealer/id6743756431"
              className="webIcons"
              target="_blank"
              style={{ marginRight: "15px" }}
            >
              <img src={app_store_img} alt="" style={{ maxWidth: "45px" }} />
            </Link>

            <Link to="/Supportpage" style={{ marginRight: "15px" }}>
              <img
                src="/assets/images/support.png"
                alt=""
                style={{ maxWidth: "50px" }}
              />
            </Link>
          </div>
        </header>
        <div id="overlay" style={{ right: menuOpen ? "0" : "100%" }}></div>

        <div className={`menubar ${menuOpen ? "open" : ""}`}>
          <span
            id="closemenu"
            onClick={handleMenuClose}
            style={{ top: menuOpen ? "0" : "-30px" }}
          >
            <span className="material-symbols-outlined">close</span>
          </span>
          <div className="user-info">
            <Link to="/Profile" className="d-flex flex-row align-items-center">
              <span>Hello,{localStorage.getItem("Ca1nioamed")}</span>
            </Link>
          </div>
          <ul id="vertical-menu">
            <li onClick={handleMenuClose}>
              <Link to="/">
                <img src="assets/images/dashboard12.png" alt="" />
                <div>
                  <span>Dashboard</span>
                  <p>Centralized cars hub</p>
                </div>
              </Link>
              <Link
                to="https://youtu.be/2YdTeUFOtjA?si=cRbwdwko4UieTJdx"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/CarInquiry">
                <img src="assets/images/add-car12.png" alt="" />
                <div>
                  <span>Add vehicle</span>
                  <p>Listing your vehicle</p>
                </div>
              </Link>
              <Link
                to="https://youtube.com/shorts/9aqb1hJaj6o?si=MKDnX-dA-wg9p5vE"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            {localStorage.getItem("loginMobile") === "7069905525" && (
              <li onClick={handleMenuClose}>
                <Link to="/mywallet">
                  <img src={walletImg} alt="" />
                  <div>
                    <span>My Wallet</span>
                    <p>Manage your wallet</p>
                  </div>
                </Link>
                <Link
                  to="https://youtube.com/shorts/9aqb1hJaj6o?si=MKDnX-dA-wg9p5vE"
                  target="_blank"
                >
                  <img src="assets/images/video.png" alt="" />
                </Link>
              </li>
            )}

            <li onClick={handleMenuClose}>
              <Link to="/MyCar">
                <img src="assets/images/car12.png" alt="" />
                <div>
                  <span>My vehicles</span>
                  <p>My vehicle portfolio</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/j5iqmI2ziZ4"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to={`/Catlogue/${localStorage.getItem("Ca1itd")}`}>
                <img src="assets/images/catalogue12.png" alt="" />
                <div>
                  <span>My catalog</span>
                  <p>Explore your portfolio</p>
                </div>
              </Link>
              <Link
                to="https://youtu.be/ULCminYzqao?si=WHPhB4iPwidALLeD"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/CreateStatus">
                <img src="assets/images/status12.png" alt="" />
                <div>
                  <span>Create status</span>
                  <p>share your vehicle status</p>
                </div>
              </Link>
              <Link
                to="https://youtube.com/shorts/D84PewM1fbc?si=18Z8sqZemm2_uVjd"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/GenerateQr">
                <img src="assets/images/qr-code12.png" alt="" />
                <div>
                  <span>Vehicle QRs</span>
                  <p>get vehicle details by scan</p>
                </div>
              </Link>
              <Link
                to="https://youtube.com/shorts/qQsKJlw9MeI?si=2Fr5t0IZ2XQ4LuU7"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/SearchDoc">
                <img src="assets/images/audit1.png" alt="" />
                <div>
                  <span>Vehicle documents</span>
                  <p>Find vehicle documents</p>
                </div>
              </Link>
              <Link
                to="https://youtube.com/shorts/8aQlridVRiw?si=bcJnOxBhAhTyDcpM"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/SalesExecutive">
                <img src="assets/images/sales-marketing.png" alt="" />
                <div>
                  <span>Add Sales Executive</span>
                  <p>List your sales executives</p>
                </div>
              </Link>
              <Link
                to="https://youtube.com/shorts/ERvyuj9j1qM?si=ce1dd_DxsH_6RD3e"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/Leaddata">
                <img src="assets/images/list1.png" alt="" />
                <div>
                  <span>Leads</span>
                  <p>Get your leadlist</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/ZzOEuhumMZ8"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to="/Addlead">
                <img src="assets/images/add-user12.png" alt="" />
                <div>
                  <span>Add lead</span>
                  <p>Add your lead</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/JTJioAjbq6Q"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            {/* <li onClick={handleMenuClose}>
              <Link to="/Stockrecord/Add">
                <img src="assets/images/addbuy.png" alt="" />
                <div>
                  <span>Buyer/Seller entry</span>
                  <p>Add new buyer or seller entry </p>
                </div>
              </Link>
            </li> */}
            <li onClick={handleMenuClose}>
              <Link to="/Stockrecord/Add">
                <img src="assets/images/addbuy.png" alt="" />
                <div>
                  <span>Buyer/Seller entry</span>
                  <p>Add new buyer or seller entry</p>
                </div>
              </Link>
              <Link
                to="https://www.youtube.com/shorts/SE-10s8k17I"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to="/Report">
                <img src="assets/images/report.png" alt="" />
                <div>
                  <span>Reports</span>
                  <p>View portfolio analytics</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/8afAzt6acms"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            {/* <li onClick={handleMenuClose}>
              <Link to="/Report">
                <img src="assets/images/report.png" alt="" />
                <div>
                  <span>Reports</span>
                  <p>View portfolio analytics</p>
                </div>
              </Link>
            </li> */}
            <li onClick={handleMenuClose}>
              <Link to="/Service">
                <img src="assets/images/service12.png" alt="" />
                <div>
                  <span>Services</span>
                  <p>Get vehicle services</p>
                </div>
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to="/AllImages">
                <img src="assets/images/all-images.png" alt="" />
                <div>
                  <span>Marketing post</span>
                  <p>Get your social-media post</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/Ir_swlFI5Zw"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to="/Trashbin">
                <img src="assets/images/trash.png" alt="" />
                <div>
                  <span>Trash Bin</span>
                  <p>Get your deleted cars here</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/O_iGMEhNPQw"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            {/* <li onClick={handleMenuClose}>
              <Link to="/Profile">
                <img src="assets/images/profile12.png" alt="" />
                <div>
                  <span>My Profile</span>
                  <p>Update Your profile</p>
                </div>
              </Link>
            </li> */}

            <li onClick={handleMenuClose}>
              <Link to="/Profile">
                <img src="assets/images/profile12.png" alt="" />
                <div>
                  <span>My Profile</span>
                  <p>Update Your profile</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/UnAM6701X_c"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to="/Changepassword">
                <img src="assets/images/security12.png" alt="" />
                <div>
                  <span>Reset password</span>
                  <p>Reset your password</p>
                </div>
              </Link>{" "}
              <Link
                to="https://www.youtube.com/shorts/CCK9_3ae1x0"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>
            <li onClick={handleMenuClose}>
              <Link to={null} onClick={(e) => OnLogout()}>
                <img src="assets/images/logout1.png" alt="" />
                <div>
                  <span>Logout</span>
                  <p>Sign out your app</p>
                </div>
              </Link>
            </li>

            <li onClick={handleMenuClose}>
              <Link to="https://carthi.in/page/accountdeletionpolicy">
                <img src={accountDeleteimg} alt="" />
                <div>
                  <span>Delete Account</span>
                  <p>
                    Permanently remove your account and all associated data.
                  </p>
                </div>
              </Link>{" "}
              <Link
                to="https://youtube.com/shorts/65aK9QGQkuM?feature=share"
                target="_blank"
              >
                <img src="assets/images/video.png" alt="" />
              </Link>
            </li>

            {localStorage.getItem("loginMobile") === "7069905525" && (
              <li onClick={handleMenuClose}>
                <Link to="/Test">
                  <img src="assets/images/logout1.png" alt="" />
                  <div>
                    <span>Test</span>
                    <p>Demo page</p>
                  </div>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
});

export default Header;

// old wihout alert icons
// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, Link, useParams } from "react-router-dom";
// import {
//   handleGetApiGF,
//   OnLogout,
//   Toast,
//   Userlogin,
// } from "./Utils/general-function";
// import useApiData from "./useApiData";
// import accountDeleteimg from "../src_img/account-delete.png";
// import play_store_img from "../src_img/playstore.png";
// import app_store_img from "../src_img/appstore.png";
// import walletImg from "../src_img/wallet.png";
// const Header = React.memo((props) => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   // const data=useApiData();
//   // console.log(data,"Header");
//   const navigate = useNavigate();
//   const menuRef = useRef(null);
//   const [profiile, setProfile] = useState({
//     firmname: sessionStorage.getItem("firmname"),
//     firmimg: sessionStorage.getItem("firmimg"),
//   });
//   //  for not showing menubar in user with not upodeted profiile
//   let nCity = "data";
//   const params = useParams();
//   console.log("par");
//   console.log("par2");

//   if (props.updated === "") {
//     nCity = props.updated;
//   }

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setMenuOpen(false);
//         const btn = document.querySelector(".sharbtnpos");
//         if (btn) {
//           btn.style.display = "inline-flex";
//         }
//       }
//     };

//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//     }
//     console.log("window.location.href", window.location.href);

//     if (
//       window.location.href !== "http://localhost:3000/" &&
//       window.location.href !== "https://m.carthi.in/"
//     ) {
//       let webIcons = document.querySelectorAll(".webIcons");
//       console.log("webIcons", webIcons);
//       if (webIcons?.length !== 0) {
//         webIcons.forEach((div) => {
//           console.log("div", div);

//           div.style.display = "none";
//         });
//       }
//     }
//   }, []);

//   const handleToggleMenu = () => {
//     setMenuOpen(!menuOpen);
//     const btn = document.querySelector(".sharbtnpos");
//     if (btn) {
//       btn.style.display = "none";
//     }
//   };

//   const handleMenuClose = () => {
//     setMenuOpen(false);
//     const btn = document.querySelector(".sharbtnpos");
//     if (btn) {
//       btn.style.display = "inline-flex";
//     }
//   };

//   const fetchProfile = async () => {
//     const profileRes = await handleGetApiGF({
//       url: "/api/BrandingProfile/All",
//     });
//     if (!profileRes.succ) {
//       Toast(false, "", profileRes?.msg);
//       return;
//     }

//     const { Firmname, Logo } = profileRes?.data?.Data[0];
//     sessionStorage.setItem("firmimg", Logo);
//     sessionStorage.setItem("firmname", Firmname);
//     setProfile((prev) => ({ ...prev, firmname: Firmname, firmimg: Logo }));
//   };

//   useEffect(() => {
//     if (Userlogin() && (!profiile.firmname || !profiile.firmimg)) {
//       fetchProfile();
//     }
//   }, []);

//   const { firmname, firmimg } = profiile;

//   return (
//     <>
//       <div className="fixheader">
//         <header className="d-flex justify-content-between align-items-center">
//           <div className="test d-flex flex-row align-items-center">
//             {nCity && (
//               <div className="menubtn" onClick={handleToggleMenu} ref={menuRef}>
//                 <span></span>
//                 <span></span>
//                 <span></span>
//               </div>
//             )}

//             <a href="/" className="logodiv">
//               <img src="/assets/images/logo.png" alt="" />
//             </a>
//           </div>
//           <div>
//             <Link
//               to="https://play.google.com/store/apps/details?id=com.app.carthi"
//               className="webIcons"
//               target="_blank"
//               style={{ marginRight: "15px" }}
//             >
//               <img src={play_store_img} alt="" style={{ maxWidth: "50px" }} />
//             </Link>
//             <Link
//               to="https://apps.apple.com/in/app/carthi-dealer/id6743756431"
//               className="webIcons"
//               target="_blank"
//               style={{ marginRight: "15px" }}
//             >
//               <img src={app_store_img} alt="" style={{ maxWidth: "45px" }} />
//             </Link>

//             <Link to="/Supportpage" style={{ marginRight: "15px" }}>
//               <img
//                 src="/assets/images/support.png"
//                 alt=""
//                 style={{ maxWidth: "50px" }}
//               />
//             </Link>
//           </div>
//         </header>
//         <div id="overlay" style={{ right: menuOpen ? "0" : "100%" }}></div>

//         <div className={`menubar ${menuOpen ? "open" : ""}`}>
//           <span
//             id="closemenu"
//             onClick={handleMenuClose}
//             style={{ top: menuOpen ? "0" : "-30px" }}
//           >
//             <span className="material-symbols-outlined">close</span>
//           </span>
//           <div className="user-info">
//             <Link to="/Profile" className="d-flex flex-row align-items-center">
//               <span>Hello,{localStorage.getItem("Ca1nioamed")}</span>
//             </Link>
//           </div>
//           <ul id="vertical-menu">
//             <li onClick={handleMenuClose}>
//               <Link to="/">
//                 <img src="assets/images/dashboard12.png" alt="" />
//                 <div>
//                   <span>Dashboard</span>
//                   <p>Centralized cars hub</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtu.be/2YdTeUFOtjA?si=cRbwdwko4UieTJdx"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/CarInquiry">
//                 <img src="assets/images/add-car12.png" alt="" />
//                 <div>
//                   <span>Add vehicle</span>
//                   <p>Listing your vehicle</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtube.com/shorts/9aqb1hJaj6o?si=MKDnX-dA-wg9p5vE"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             {localStorage.getItem("loginMobile") === "7069905525" && (
//               <li onClick={handleMenuClose}>
//                 <Link to="/mywallet">
//                   <img src={walletImg} alt="" />
//                   <div>
//                     <span>My Wallet</span>
//                     <p>Manage your wallet</p>
//                   </div>
//                 </Link>
//                 <Link
//                   to="https://youtube.com/shorts/9aqb1hJaj6o?si=MKDnX-dA-wg9p5vE"
//                   target="_blank"
//                 >
//                   <img src="assets/images/video.png" alt="" />
//                 </Link>
//               </li>
//             )}

//             <li onClick={handleMenuClose}>
//               <Link to="/MyCar">
//                 <img src="assets/images/car12.png" alt="" />
//                 <div>
//                   <span>My vehicles</span>
//                   <p>My vehicle portfolio</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/j5iqmI2ziZ4"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to={`/Catlogue/${localStorage.getItem("Ca1itd")}`}>
//                 <img src="assets/images/catalogue12.png" alt="" />
//                 <div>
//                   <span>My catalog</span>
//                   <p>Explore your portfolio</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtu.be/ULCminYzqao?si=WHPhB4iPwidALLeD"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/CreateStatus">
//                 <img src="assets/images/status12.png" alt="" />
//                 <div>
//                   <span>Create status</span>
//                   <p>share your vehicle status</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtube.com/shorts/D84PewM1fbc?si=18Z8sqZemm2_uVjd"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/GenerateQr">
//                 <img src="assets/images/qr-code12.png" alt="" />
//                 <div>
//                   <span>Vehicle QRs</span>
//                   <p>get vehicle details by scan</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtube.com/shorts/qQsKJlw9MeI?si=2Fr5t0IZ2XQ4LuU7"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/SearchDoc">
//                 <img src="assets/images/audit1.png" alt="" />
//                 <div>
//                   <span>Vehicle documents</span>
//                   <p>Find vehicle documents</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtube.com/shorts/8aQlridVRiw?si=bcJnOxBhAhTyDcpM"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/SalesExecutive">
//                 <img src="assets/images/sales-marketing.png" alt="" />
//                 <div>
//                   <span>Add Sales Executive</span>
//                   <p>List your sales executives</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://youtube.com/shorts/ERvyuj9j1qM?si=ce1dd_DxsH_6RD3e"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/Leaddata">
//                 <img src="assets/images/list1.png" alt="" />
//                 <div>
//                   <span>Leads</span>
//                   <p>Get your leadlist</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/ZzOEuhumMZ8"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to="/Addlead">
//                 <img src="assets/images/add-user12.png" alt="" />
//                 <div>
//                   <span>Add lead</span>
//                   <p>Add your lead</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/JTJioAjbq6Q"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             {/* <li onClick={handleMenuClose}>
//               <Link to="/Stockrecord/Add">
//                 <img src="assets/images/addbuy.png" alt="" />
//                 <div>
//                   <span>Buyer/Seller entry</span>
//                   <p>Add new buyer or seller entry </p>
//                 </div>
//               </Link>
//             </li> */}
//             <li onClick={handleMenuClose}>
//               <Link to="/Stockrecord/Add">
//                 <img src="assets/images/addbuy.png" alt="" />
//                 <div>
//                   <span>Buyer/Seller entry</span>
//                   <p>Add new buyer or seller entry</p>
//                 </div>
//               </Link>
//               <Link
//                 to="https://www.youtube.com/shorts/SE-10s8k17I"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to="/Report">
//                 <img src="assets/images/report.png" alt="" />
//                 <div>
//                   <span>Reports</span>
//                   <p>View portfolio analytics</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/8afAzt6acms"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             {/* <li onClick={handleMenuClose}>
//               <Link to="/Report">
//                 <img src="assets/images/report.png" alt="" />
//                 <div>
//                   <span>Reports</span>
//                   <p>View portfolio analytics</p>
//                 </div>
//               </Link>
//             </li> */}
//             <li onClick={handleMenuClose}>
//               <Link to="/Service">
//                 <img src="assets/images/service12.png" alt="" />
//                 <div>
//                   <span>Services</span>
//                   <p>Get vehicle services</p>
//                 </div>
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to="/AllImages">
//                 <img src="assets/images/all-images.png" alt="" />
//                 <div>
//                   <span>Marketing post</span>
//                   <p>Get your social-media post</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/Ir_swlFI5Zw"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to="/Trashbin">
//                 <img src="assets/images/trash.png" alt="" />
//                 <div>
//                   <span>Trash Bin</span>
//                   <p>Get your deleted cars here</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/O_iGMEhNPQw"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             {/* <li onClick={handleMenuClose}>
//               <Link to="/Profile">
//                 <img src="assets/images/profile12.png" alt="" />
//                 <div>
//                   <span>My Profile</span>
//                   <p>Update Your profile</p>
//                 </div>
//               </Link>
//             </li> */}

//             <li onClick={handleMenuClose}>
//               <Link to="/Profile">
//                 <img src="assets/images/profile12.png" alt="" />
//                 <div>
//                   <span>My Profile</span>
//                   <p>Update Your profile</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/UnAM6701X_c"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to="/Changepassword">
//                 <img src="assets/images/security12.png" alt="" />
//                 <div>
//                   <span>Reset password</span>
//                   <p>Reset your password</p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://www.youtube.com/shorts/CCK9_3ae1x0"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>
//             <li onClick={handleMenuClose}>
//               <Link to={null} onClick={(e) => OnLogout()}>
//                 <img src="assets/images/logout1.png" alt="" />
//                 <div>
//                   <span>Logout</span>
//                   <p>Sign out your app</p>
//                 </div>
//               </Link>
//             </li>

//             <li onClick={handleMenuClose}>
//               <Link to="https://carthi.in/page/accountdeletionpolicy">
//                 <img src={accountDeleteimg} alt="" />
//                 <div>
//                   <span>Delete Account</span>
//                   <p>
//                     Permanently remove your account and all associated data.
//                   </p>
//                 </div>
//               </Link>{" "}
//               <Link
//                 to="https://youtube.com/shorts/65aK9QGQkuM?feature=share"
//                 target="_blank"
//               >
//                 <img src="assets/images/video.png" alt="" />
//               </Link>
//             </li>

//             {localStorage.getItem("loginMobile") === "7069905525" && (
//               <li onClick={handleMenuClose}>
//                 <Link to="/Test">
//                   <img src="assets/images/logout1.png" alt="" />
//                   <div>
//                     <span>Test</span>
//                     <p>Demo page</p>
//                   </div>
//                 </Link>
//               </li>
//             )}
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// });

// export default Header;
